import { render, staticRenderFns } from "./AbbreviatedLabeledValue.vue?vue&type=template&id=0f260977&"
import script from "./AbbreviatedLabeledValue.vue?vue&type=script&lang=ts&"
export * from "./AbbreviatedLabeledValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports